import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Palette } from '@/themes/themeOverrides/Palette';
import { useTranslate } from 'react-admin';
import SummaryStepDiscountInfo from '@/components/promotionalCampaigns/campaign/SummaryStepDiscountInfo';
import SummaryStepProductsInfo from '@/components/promotionalCampaigns/campaign/SummaryStepProductsInfo';
import SummaryStepCriteriaInfo from '@/components/promotionalCampaigns/campaign/SummaryStepCriteriaInfo';
import SummaryStepEmissionInfo from '@/components/promotionalCampaigns/campaign/SummaryStepEmissionInfo';

const StyledSummaryStep = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    width: '492px',
    '& .summary-tile': {
        padding: '32px 40px',
        borderRadius: '20px',
        backgroundColor: Palette.gray.gray75,
        textTransform: 'uppercase',
    },
}));

const SummaryStep = () => {
    const translate = useTranslate();
    return (
        <StyledSummaryStep>
            <Box className='summary-tile'>
                <Typography variant='caption' className='group-heading'>
                    {translate('resources.campaign.labels.summary.promotion')}
                </Typography>
                <Box sx={{ marginTop: '16px' }}>
                    <SummaryStepDiscountInfo />
                </Box>
            </Box>
            <Box className='summary-tile'>
                <Typography variant='caption' className='group-heading'>
                    {translate('resources.campaign.labels.summary.products')}
                </Typography>
                <Box sx={{ marginTop: '16px' }}>
                    <SummaryStepProductsInfo />
                </Box>
            </Box>
            <Box className='summary-tile'>
                <Typography variant='caption' className='group-heading'>
                    {translate('resources.campaign.labels.summary.criteria')}
                </Typography>
                <Box sx={{ marginTop: '16px' }}>
                    <SummaryStepCriteriaInfo />
                </Box>
            </Box>
            <Box className='summary-tile'>
                <Typography variant='caption' className='group-heading'>
                    {translate('resources.campaign.labels.summary.emission')}
                </Typography>
                <Box sx={{ marginTop: '16px' }}>
                    <SummaryStepEmissionInfo />
                </Box>
            </Box>
        </StyledSummaryStep>
    );
};

export default SummaryStep;
